import React, { Component } from "react";

class GameBox extends Component {
  render() {
    const { game } = this.props;
    return (
      <div className="col-md-4 col-sm-6 box"> <img src={game.logo_path} alt="" />
        <div className="box1"> <span className="gamename"><font style={{color: "#fff"}}>{game.game_name}</font></span><br />
          <span>
            <a href={game.vip_wire_report_os===1?`/wire_report_portal/${game.game_id}`:`/wire_report_v2/${game.game_id}`} target="_blank" rel="noopener noreferrer">儲值</a> | 
            <a href={game.site} target="_blank" rel="noopener noreferrer">官網</a> | 
            <a href={`/service_quick?param_game_id=${game.game_id}`} target="_blank" rel="noopener noreferrer">客服</a> | 
            <a href={game.fanpage} target="_blank" rel="noopener noreferrer">粉絲團</a>
          </span> 
        </div>
      </div>
    );
  }
}

export default GameBox;
